<template>
	<div class="HomepageScreen">
		<div class="Wrapper">
			<div class="Cover">
				<h2>
					Club deportivo<br />
					<!-- <span>ESPARTANAS</span><br /> -->
					<svg class="Logo" fill="#3edad8" xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="1200px"
						height="304px" viewBox="-70 0 1200 304" enable-background="new -70 0 1200 304" xml:space="preserve">
						<g>
							<path
								d="M-16.057,300.307l-51.387-92.865c-0.611-1.348-0.943-2.824-0.958-4.455c-0.011-1.903,0.248-3.5,0.807-4.856   c5.254-10.88,10.398-21.94,15.407-33.255c5.016-11.275,7.506-17.749,7.485-19.356c-0.017-1.081-2.646-8.328-7.888-21.772   c-0.874-2.126-6.413-16.139-16.65-41.893c-0.491-1.098-0.757-2.272-0.758-3.656c-0.022-1.325,0.189-2.408,0.657-3.233   c11.521-15.831,23.066-31.68,34.604-47.508C-21.713,9.732-14.793,0.842-13.967,0.843c4.03,9.94,6.947,17.313,8.775,22.139   c5.755,14.785,8.612,22.976,8.647,24.604C-4.28,57.958-9.983,65.761-13.681,70.929c-11.293,15.58-16.921,24.285-16.91,26.188   c0.009,0.246,1.249,3.315,3.668,9.241c8.279,19.599,13.5,32.246,15.723,37.868c0.474,1.085,0.715,2.188,0.74,3.238   c-0.004,0.558-0.223,1.621-0.672,3.245c-1.918,5.436-5.941,15.35-12.091,29.784c-3.963,9.229-5.934,15.319-5.899,18.282   c0.035,3.527,4.531,13.701,13.464,30.617c7.861,15.01,12.447,23.379,13.765,25.119c1.31,1.752,2.229,3.024,2.718,3.809   c1.532,2.412,2.335,4.162,2.359,5.246L-16.057,300.307z" />
							<path
								d="M121.271,206.779L77.123,304l-26.059-45.896l30.401-62.676c0.477-0.816,0.791-1.52,0.98-2.054   c0.644-1.595,0.872-3.372,0.661-5.155c-0.289-2.607-1.089-5.015-2.42-7.242L44.601,123.04c-2.248-4.507-3.667-8.942-4.149-13.337   c-0.534-4.653-0.162-9.146,1.126-13.451c0.443-1.334,1.142-2.975,2.109-4.903L86.417,0.51l23.621,46.106l-27.314,55.37   c-0.595,1.121-1.03,1.94-1.332,2.483c-0.798,2.138-1.127,4.155-0.913,5.958c0.228,2.067,0.897,3.708,1.968,4.929l37.678,60.91   c0.743,1.496,1.277,2.647,1.617,3.407c1.128,2.752,1.885,5.709,2.221,8.824c0.315,2.833,0.279,5.763-0.145,8.812   C123.395,200.359,122.554,203.507,121.271,206.779" />
							<path
								d="M230.625,151.313c9.436-20.77,14.196-32.435,14.218-34.954c0.037-5.328-2.594-14.082-7.887-26.355   c-4.249-9.768-10.722-23.13-19.352-40.125c-7.86-15.043-15.708-30.236-23.551-45.571c-0.698-1.407-1.52-2.106-2.454-2.094   c-0.349-0.002-0.751,0.136-1.243,0.453c-1.052,0.833-1.882,1.422-2.458,1.688c-5.08,3.136-9.573,6.45-13.453,9.974   c-3.886,3.563-6.4,6.439-7.472,8.678l-2.228,275.38c5.65-2.273,9.855-3.965,12.58-5.117c8.379-3.438,12.578-5.549,12.592-6.42   l0.367-47.844c0.027-0.843,4.754-11.387,14.229-31.643C217.445,179.861,226.168,161.15,230.625,151.313 M201.732,136.54   c-1.793,3.367-4.489,8.572-8.067,15.581l-1.942,0.015l0.614-73.875l1.565,0.017c1.179-0.034,4.151,5.282,8.893,15.88   c4.747,10.582,7.103,17.804,7.059,21.752C209.841,118.95,207.12,125.872,201.732,136.54" />
							<path
								d="M370.249,271.174L333.026,34.275c-1.722-11.121-2.671-17.534-2.908-19.202c-1.378-8.332-2.47-12.512-3.288-12.517   l-16.823,10.966c-2.928,2.215-5.892,4.306-8.851,6.264c-0.339,0.304-1.374,6.291-3.085,17.965L263.49,271.646   c-0.015,1.971,3.393,5.83,10.19,11.646c2.46,1.948,7.198,5.819,14.225,11.63l5.3-35.941c2.167-14.438,3.528-23.49,4.063-27.115   c0.551-3.623,1.478-5.44,2.777-5.448l35.452-0.159c1.066-0.027,2.045,3.449,2.966,10.395c1.594,12.244,2.734,19.965,3.44,23.17   c0.675,3.18,2.053,12.007,4.099,26.48c0.235,1.944,0.641,4.711,1.202,8.329c1.177-0.011,4.109-2.241,8.84-6.726   c0.818-0.522,1.948-1.795,3.39-3.752c2.581-3.365,5.54-6.284,8.843-8.813C369.832,274.203,370.463,272.822,370.249,271.174    M307.185,167.123l10.009-64.316c2.165,12.772,4.522,26.971,7.045,42.495c1.727,10.307,2.789,17,3.253,20.059l-0.002,1.654   L307.185,167.123z" />
							<path
								d="M490.333,200.254c-10.031-25.294-15.075-38.579-15.125-39.954c-0.115-3.224,2.053-11.555,6.466-24.994   c3.261-9.825,6.024-19.405,8.24-28.656c0.322-1.365,0.427-2.455,0.406-3.266c-0.01-1.069-0.268-2.276-0.658-3.596   c-6.26-15.998-16.34-39.36-30.221-70.219c-4.878-10.87-7.344-16.867-7.395-17.921c-1.116-1.588-2.37-3.024-3.79-4.353   c-1.371-1.291-2.876-1.881-4.524-1.821c-0.595-0.015-1.707,0.309-3.301,0.933c-0.202,0.557-5.704,3.875-16.509,9.94   c-3.546,2.025-8.952,5.082-16.163,9.123l10.382,271.157c4.5-2.04,9.037-4.111,13.523-6.177c8.851-5.442,13.797-8.884,14.781-10.279   l-3.805-99.548l2.233,3.189c1.137,2.369,5.539,12.877,13.169,31.5c6.613,16.513,13.318,33.043,20.108,49.646   c6.806,16.65,10.499,24.926,11.084,24.909c0.598-0.024,2.769-2.937,6.531-8.747c4.766-7.479,9.582-15.072,14.448-22.821l2.311-3.78   C506.556,240.415,499.158,222.369,490.333,200.254 M450.958,130.471c-4.831,9.108-8.031,14.488-9.628,16.196l-3.066-80.106   c4.643,7.393,8.075,12.923,10.343,16.606c7.044,11.89,10.646,19.601,10.772,23.075   C459.556,111.387,456.773,119.446,450.958,130.471" />
							<path
								d="M122.271,206.779L78.123,304l-26.059-45.896l30.401-62.676c0.477-0.816,0.791-1.52,0.98-2.054   c0.644-1.595,0.872-3.372,0.661-5.155c-0.289-2.607-1.089-5.015-2.42-7.242L45.601,123.04c-2.248-4.507-3.667-8.942-4.149-13.337   c-0.534-4.653-0.162-9.146,1.126-13.451c0.443-1.334,1.142-2.975,2.109-4.903L87.417,0.51l23.621,46.106l-27.314,55.37   c-0.595,1.121-1.03,1.94-1.332,2.483c-0.798,2.138-1.127,4.155-0.913,5.958c0.228,2.067,0.897,3.708,1.968,4.929l37.678,60.91   c0.743,1.496,1.277,2.647,1.617,3.407c1.128,2.752,1.885,5.709,2.221,8.824c0.315,2.833,0.279,5.763-0.145,8.812   C124.395,200.359,123.554,203.507,122.271,206.779" />
							<path
								d="M231.625,151.313c9.436-20.77,14.196-32.435,14.218-34.954c0.037-5.328-2.594-14.082-7.887-26.355   c-4.249-9.768-10.722-23.13-19.352-40.125c-7.86-15.043-15.708-30.236-23.551-45.571c-0.698-1.407-1.52-2.106-2.454-2.094   c-0.349-0.002-0.751,0.136-1.243,0.453c-1.052,0.833-1.882,1.422-2.458,1.688c-5.08,3.136-9.573,6.45-13.453,9.974   c-3.886,3.563-6.4,6.439-7.472,8.678l-2.228,275.38c5.65-2.273,9.855-3.965,12.58-5.117c8.379-3.438,12.578-5.549,12.592-6.42   l0.367-47.844c0.027-0.843,4.754-11.387,14.229-31.643C218.445,179.861,227.168,161.15,231.625,151.313 M202.732,136.54   c-1.793,3.367-4.489,8.572-8.067,15.581l-1.942,0.015l0.614-73.875l1.565,0.017c1.179-0.034,4.151,5.282,8.893,15.88   c4.747,10.582,7.103,17.804,7.059,21.752C210.841,118.95,208.12,125.872,202.732,136.54" />
							<path
								d="M371.249,271.174L334.026,34.275c-1.722-11.121-2.671-17.534-2.908-19.202c-1.378-8.332-2.47-12.512-3.288-12.517   l-16.823,10.966c-2.928,2.215-5.892,4.306-8.851,6.264c-0.339,0.304-1.374,6.291-3.085,17.965L264.49,271.646   c-0.015,1.971,3.393,5.83,10.19,11.646c2.46,1.948,7.198,5.819,14.225,11.63l5.3-35.941c2.167-14.438,3.528-23.49,4.063-27.115   c0.551-3.623,1.478-5.44,2.777-5.448l35.452-0.159c1.066-0.027,2.045,3.449,2.966,10.395c1.594,12.244,2.734,19.965,3.44,23.17   c0.675,3.18,2.053,12.007,4.099,26.48c0.235,1.944,0.641,4.711,1.202,8.329c1.177-0.011,4.109-2.241,8.84-6.726   c0.818-0.522,1.948-1.795,3.39-3.752c2.581-3.365,5.54-6.284,8.843-8.813C370.832,274.203,371.463,272.822,371.249,271.174    M308.185,167.123l10.009-64.316c2.165,12.772,4.522,26.971,7.045,42.495c1.727,10.307,2.789,17,3.253,20.059l-0.002,1.654   L308.185,167.123z" />
							<path
								d="M491.333,200.254c-10.031-25.294-15.075-38.579-15.125-39.954c-0.115-3.224,2.053-11.555,6.466-24.994   c3.261-9.825,6.024-19.405,8.24-28.656c0.322-1.365,0.427-2.455,0.406-3.266c-0.01-1.069-0.268-2.276-0.658-3.596   c-6.26-15.998-16.34-39.36-30.221-70.219c-4.878-10.87-7.344-16.867-7.395-17.921c-1.116-1.588-2.37-3.024-3.79-4.353   c-1.371-1.291-2.876-1.881-4.524-1.821c-0.595-0.015-1.707,0.309-3.301,0.933c-0.202,0.557-5.704,3.875-16.509,9.94   c-3.546,2.025-8.952,5.082-16.163,9.123l10.382,271.157c4.5-2.04,9.037-4.111,13.523-6.177c8.851-5.442,13.797-8.884,14.781-10.279   l-3.805-99.548l2.233,3.189c1.137,2.369,5.539,12.877,13.169,31.5c6.613,16.513,13.318,33.043,20.108,49.646   c6.806,16.65,10.499,24.926,11.084,24.909c0.598-0.024,2.769-2.937,6.531-8.747c4.766-7.479,9.582-15.072,14.448-22.821l2.311-3.78   C507.556,240.415,500.158,222.369,491.333,200.254 M451.958,130.471c-4.831,9.108-8.031,14.488-9.628,16.196l-3.066-80.106   c4.643,7.393,8.075,12.923,10.343,16.606c7.044,11.89,10.646,19.601,10.772,23.075   C460.556,111.387,457.773,119.446,451.958,130.471" />
						</g>
						<polygon
							points="595.863,60.794 597.807,274.061 569.898,289.678 567.815,59.843 525.833,60.638 537.523,5.063 637.141,4.151   624.938,60.554 " />
						<polygon
							points="866.504,291.555 818.708,130.878 820.006,281.335 791.183,293.635 788.745,17.103 817.612,4.476 862.318,153.982   861.1,11.437 886.81,0 889.238,281.505 " />
						<path
							d="M755.185,271.174L717.962,34.275c-1.72-11.121-2.671-17.534-2.907-19.202c-1.379-8.332-2.471-12.512-3.289-12.517  l-16.821,10.966c-2.929,2.215-5.893,4.306-8.854,6.264c-0.338,0.304-1.373,6.291-3.084,17.965l-34.581,233.896  c-0.016,1.971,3.395,5.83,10.19,11.646c2.462,1.948,7.199,5.819,14.226,11.63l5.3-35.941c2.167-14.438,3.528-23.49,4.063-27.115  c0.551-3.623,1.479-5.44,2.778-5.448l35.451-0.159c1.067-0.027,2.046,3.449,2.967,10.395c1.595,12.244,2.732,19.965,3.439,23.17  c0.675,3.18,2.054,12.007,4.101,26.48c0.234,1.944,0.64,4.711,1.201,8.329c1.178-0.011,4.108-2.241,8.841-6.726  c0.816-0.522,1.946-1.795,3.39-3.752c2.581-3.365,5.539-6.284,8.842-8.813C754.769,274.203,755.4,272.822,755.185,271.174   M692.121,167.123l10.009-64.316c2.165,12.772,4.521,26.971,7.045,42.495c1.727,10.307,2.788,17,3.254,20.059l-0.002,1.654  L692.121,167.123z" />
						<path
							d="M1029.138,271.174L991.915,34.275c-1.721-11.121-2.672-17.534-2.907-19.202c-1.379-8.332-2.471-12.512-3.289-12.517  l-16.823,10.966c-2.927,2.215-5.891,4.306-8.853,6.264c-0.337,0.304-1.372,6.291-3.084,17.965l-34.58,233.896  c-0.016,1.971,3.394,5.83,10.189,11.646c2.463,1.948,7.198,5.819,14.226,11.63l5.3-35.941c2.167-14.438,3.529-23.49,4.063-27.115  c0.552-3.623,1.479-5.44,2.777-5.448l35.452-0.159c1.067-0.027,2.045,3.449,2.967,10.395c1.595,12.244,2.733,19.965,3.439,23.17  c0.675,3.18,2.054,12.007,4.1,26.48c0.235,1.944,0.642,4.711,1.202,8.329c1.179-0.011,4.108-2.241,8.841-6.726  c0.817-0.522,1.947-1.795,3.39-3.752c2.582-3.365,5.54-6.284,8.843-8.813C1028.721,274.203,1029.354,272.822,1029.138,271.174   M966.074,167.123l10.008-64.316c2.165,12.772,4.521,26.971,7.045,42.495c1.727,10.307,2.789,17,3.254,20.059l-0.002,1.654  L966.074,167.123z" />
						<path
							d="M1127.1,206.779L1082.951,304l-26.06-45.896l30.399-62.676c0.479-0.816,0.792-1.52,0.979-2.054  c0.646-1.595,0.872-3.372,0.663-5.155c-0.29-2.607-1.09-5.015-2.421-7.242l-36.085-57.937c-2.249-4.507-3.668-8.942-4.147-13.337  c-0.535-4.653-0.163-9.146,1.126-13.451c0.442-1.334,1.142-2.975,2.107-4.903l42.73-90.839l23.621,46.106l-27.314,55.37  c-0.594,1.121-1.029,1.94-1.332,2.483c-0.798,2.138-1.127,4.155-0.912,5.958c0.229,2.067,0.896,3.708,1.968,4.929l37.679,60.91  c0.743,1.496,1.276,2.647,1.614,3.407c1.13,2.752,1.887,5.709,2.223,8.824c0.314,2.833,0.277,5.763-0.146,8.812  C1129.225,200.359,1128.383,203.507,1127.1,206.779" />
					</svg>
					<br />
					<b>Kickingball</b> Madrid
				</h2>
				<iframe v-if="!isTablet" class="Video"
					src="https://www.youtube.com/embed/HlB4pF1Ge50?controls=0&modestbranding=1&rel=0&showinfo=0"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen />

				<div class="CoverImage"
					:style="{ backgroundImage: `url(${require(`@/assets/imgs/main/photo-main.webp`)})` }"></div>
			</div>

			<SectionWrapper :useGradientBackground="false">
				<div class="CenteredTextWrapper">
					<p>
						<b>Pioneras del kickingball en Madrid</b>
					</p>
					<p>Activas de forma ininterrumpida desde 2015</p>
					<p>
						3 veces campeonas de la Liga
					</p>
					<p class="highlight">¡AU! ¡AU!</p>
				</div>
			</SectionWrapper>

			<SplideWrapper v-if="lastEvents.length" :items="lastEvents" title="Últimos partidos" type="Shorts"
				:backgroundImage="require(`@/assets/imgs/main/photo-02.webp`)" :imageOpacity="0.3"
				description="Juego completo y resumen en YouTube" :contentSize="{ width: 315, height: 420 }">
			</SplideWrapper>

			<SplideWrapper v-if="upcomingEvents.length" :items="upcomingEvents" title="Próximos partidos" type="Events"
				:useArrows="false" description="En directo en YouTube" :heightAuto="false"
				:contentSize="{ width: 231, height: 410 }">
			</SplideWrapper>


			<!-- title="Sobre nosotras" -->
			<SectionWrapper class="AboutUs" title="Somos Espartanas"
				:backgroundImage="require(`@/assets/imgs/main/photo-03.webp`)">
				<div class="TextWrapper">
					<h3 class="lema">Somos la suma del esfuerzo de todas.</h3>
					<div class="TextContent">
						<p>Desde 2015, hemos crecido dentro y fuera del campo, <b>construyendo un equipo</b> que se
							nutre de
							cada
							experiencia y de cada persona que ha pasado por él.</p>
					</div>
					<div class="TextContent">
						<!-- <Icon icon="heart" :size="20" color="primary" /> -->
						<p>Nuestra identidad se basa en el compromiso, el trabajo en equipo y la constancia.
							<!-- Somos la
							suma
							del
							esfuerzo de todas,  -->
							<br />
							Tenemos un objetivo común: <b>hacer brillar nuestro escudo</b>.
						</p>
					</div>
					<div class="TextContent">
						<!-- <Icon icon="book-open" :size="20" color="primary" /> -->
						<p>Nos caracteriza un estilo de <b>juego estratégico</b> y un sólido conocimiento del
							reglamento.
						</p>
					</div>
					<div class="TextContent">
						<!-- <Icon icon="star" :size="20" color="primary" /> -->

						<p class="CustomIcon">🏆</p>
						<p>En 7 ediciones de liga, hemos sido <b>campeonas 3 veces</b> y hemos subido al podio en otras
							3.
						</p>
					</div>
					<!-- ⚽️🔥🤓🏆 -->
				</div>
			</SectionWrapper>

			<SectionWrapper :useGradientBackground="false">
				<div class="PicturesWrapper">
					<div class="TeamPicture"
						:style="{ backgroundImage: `url(${require(`@/assets/imgs/main/photo-08.webp`)})` }" />
					<div class="TeamPicture short"
						:style="{ backgroundImage: `url(${require(`@/assets/imgs/main/photo-10.webp`)})` }" />
				</div>
			</SectionWrapper>

			<div class="SocialMediaSection">
				<div class="Image" :style="{ backgroundImage: `url(${require(`@/assets/imgs/main/photo-05.webp`)})` }" />
				<div class="SocialsWrapper">
					<a v-for="(   { name, link, icon, url }, index   ) in    socialMedia.slice(1)   " :key="index"
						class="SocialMedia" :href="link" target="_blank">
						<div class="Icon">
							<Icon :icon="icon" :size="28" color="white" />
						</div>
						<div class="Info">
							<p class="Title">{{ name }}</p>
							<p>{{ url }}</p>
						</div>
					</a>
				</div>
			</div>
			<!-- <div class="SponsorSection">
				<p>Sponsor principal</p>
				<a v-for="({ link, image }, index) in sponsors" :key="index" :href="link" target="_blank">
					<img :src="require(`@/assets/imgs/sponsors/${image}.png`)" class="Sponsor" />
				</a>
			</div> -->
			<!-- <div class="SponsorSection">
				<p>Con la colaboración de:</p>
				<a v-for="({ link, image }, index) in sponsors" :key="index" :href="link" target="_blank">
					<img :src="require(`@/assets/imgs/sponsors/${image}.png`)" class="Sponsor" />
				</a>
			</div> -->
		</div>
	</div>
</template>

<script>
import { mediaQueryMixin } from "@/mixins";
import moment from "moment";
import { SplideWrapper, SectionWrapper } from '@/components'
import { sponsors, socialMedia } from '@/utils/publicData'
import { events } from '@/utils/events'

export default {
	name: "HomepageScreen",
	components: {
		SplideWrapper,
		SectionWrapper
	},
	mixins: [mediaQueryMixin],
	data() {
		return {
			sponsors,
			socialMedia,
			events,
		};
	},
	computed: {
		isMobile() {
			return this.$mq.w < this.$mq.sm.min;
		},
		isTablet() {
			return this.$mq.w < this.$mq.md.min;
		},
		upcomingEvents() {
			const events = this.events.filter(e => !this.isPastDate(e.date))
			return events.reverse()
		},
		lastEvents() {
			return this.events.filter(e => this.isPastDate(e.date))
		},
	},
	methods: {
		isPastDate(date) {
			const today = moment();
			return moment(date).isBefore(today);
		},
	},
};
</script>
<style lang="scss" scoped>
@font-face {
	font-family: 'adonais';
	src: url('~@/assets/fonts/Adonais.ttf') format('truetype');
}

.HomepageScreen {
	width: 100%;
	min-height: 100vh;
	background: #333;

	.Wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		.Cover {
			height: 30rem;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;

			@media screen and (max-width: $sm) {
				height: 25rem;
			}

			* {
				z-index: 1;
			}

			h2 {
				font-weight: $font-weight-normal;
				text-align: center;
				font-size: 1.5rem;
				color: white;

				span {
					font-weight: $font-weight-bold;
					font-size: 2.8rem;
					line-height: 4rem;
					color: $primary;
				}
			}

			.Logo {
				width: auto;
				height: 5rem;
				color: $primary;
				margin: 1rem 0;

				@media screen and (max-width: $md) {
					height: 4.5rem;
				}

				@media screen and (max-width: $sm) {
					height: 4rem;
				}
			}

			.Video {
				position: absolute;
				bottom: 2rem;
				left: 2rem;
				border-radius: 20px;
				border: 5px solid rgba(white, 0.1);
				box-shadow: 0 2px 5px 0 rgba(black, 0.1);
			}

			.CoverImage {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-repeat: no-repeat;
				background-position-x: center;
				background-position-y: top;
				opacity: 0.2;
				position: absolute;
				z-index: 0;
			}
		}


		.AboutUs {
			padding-top: 5rem;
		}

		.TextWrapper {
			width: 80%;
			padding-bottom: 3rem;

			.lema {
				font-size: 2.3rem;
				color: #fff;
				line-height: 3rem;
				margin: 0rem 0 4rem 0 !important;
				padding: 0 !important;
			}

			.TextContent {
				display: flex;
				margin-bottom: 1.5rem;

				@media screen and (min-width: $xl) {

					width: 80%;

				}

				.Icon,
				.CustomIcon {
					margin-right: 20px;
					margin-top: 4px;
				}

				.CustomIcon {
					font-size: 2rem;
				}

				p {
					font-size: 1rem;
				}
			}

			@media screen and (min-width: $xl) {
				width: 1300px;
				align-self: center;
			}

			@media screen and (max-width: $md) {
				width: 100%;
			}
		}

		.CenteredTextWrapper {
			align-items: center;
			justify-content: center;
			text-align: center;

			* {
				color: #fff;
				text-align: center;
			}

			.highlight {
				color: $primary;
				font-size: 1.5rem;
				font-weight: $font-weight-bold;
				margin-top: 1.5rem;
				font-family: 'adonais', 'Mukta', 'Open Sans';
			}
		}

		.PicturesWrapper {
			display: flex;
			flex-direction: row;
			width: 100%;
			gap: 20px;

			@media screen and (min-width: $xl) {
				width: 1300px;
				align-items: center;
			}

			@media screen and (max-width: $md) {
				flex-direction: column;
			}

			.TeamPicture {
				width: 50%;
				flex: 1;
				height: 450px;
				border-radius: 20px;
				background-size: cover;
				background-repeat: no-repeat;
				background-position-x: center;
				background-position-y: center;

				&.short {
					max-width: 40%;


					@media screen and (max-width: $md) {
						min-height: 450px;
						height: 450px;
						width: 100%;
						max-width: 100%;
					}

					@media screen and (max-width: $sm) {
						min-height: 250px;
						height: 250px;
						width: 100%;
						max-width: 100%;
					}
				}

				@media screen and (max-width: $md) {
					min-height: 420px;
					height: 420px;
					width: 100%;
					max-width: 100%;
				}

				@media screen and (max-width: $sm) {
					min-height: 250px;
					height: 250px;
					width: 100%;
					max-width: 100%;
				}


			}
		}

		.SocialMediaSection {
			display: flex;
			width: 100%;
			height: 40rem;
			position: relative;

			@media screen and (max-width: $sm) {
				height: 30rem;
			}

			.Image {
				width: 50%;
				top: 0;
				left: 0;
				background-size: cover;
				background-repeat: no-repeat;
				background-position-x: center;
				background-position-y: center;
				border-top-right-radius: 30px;
				overflow: hidden;

				@media screen and (max-width: $sm) {
					min-width: 100%;
					opacity: 0.5;
					border-top-right-radius: 0px;
				}
			}

			.SocialsWrapper {
				transform: translateX(-5rem);
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;

				@media screen and (max-width: $sm) {
					transform: translateX(0);
					position: absolute;
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
				}

				.SocialMedia {
					display: flex;

					&+.SocialMedia {
						margin-top: 3rem;
					}

					&:hover {
						.Info {
							transform: scale(1.1);
						}

						.Icon:before {
							transform: scale(1.3);
						}
					}

					.Icon {
						width: 7rem;
						height: 7rem;
						border-radius: 50%;
						background: $primary;
						display: flex;
						justify-content: center;
						align-items: center;

						@media screen and (max-width: $sm) {
							width: 4rem;
							height: 4rem;
						}

						&:before {
							transition: all 0.3s;
						}
					}

					.Info {
						display: flex;
						flex-direction: column;
						justify-content: center;
						margin-left: 36px;
						transition: all 0.3s;

						// @media screen and (max-width: $sm) {
						// 	align-items: center;
						// 	margin-left: 0;
						// }

						p {
							color: white;
							font-size: 1rem;
						}

						.Title {
							font-size: 1.5rem;
							line-height: 36px;
							margin-bottom: 8px;
							font-weight: bold;
						}
					}
				}
			}
		}

		.SponsorSection {
			width: 100%;
			padding: 3rem;
			background: white;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			p {
				color: $gray-dark;
				text-align: center;
			}

			.Sponsor {
				width: auto;
				height: 180px;
				margin-top: 20px;
			}
		}

	}

	.TextWrapper {
		width: 80%;

		@media screen and (min-width: $xl) {
			width: 1300px;
			align-self: center;

			.TextContent {
				width: 80%;
			}
		}

		@media screen and (max-width: $md) {
			width: 100%;
		}
	}

	.TextContent {
		display: flex;
		margin-bottom: 1.5rem;

		.Icon {
			margin-right: 20px;
			margin-top: 4px;
		}

		p {
			font-size: 1rem;
		}
	}
}
</style>
